<template>
  <div class="skeleton">
    <div class="skeleton__header">
      <div class="skeleton__box" />
    </div>
    <div class="skeleton__subheader">
      <div class="skeleton__box" />
    </div>
    <div class="skeleton__body">
      <div class="skeleton__picture">
        <div class="skeleton__box" />
      </div>
      <div class="skeleton__content">
        <div class="skeleton__row">
          <div class="skeleton__box" />
        </div>
        <div class="skeleton__row">
          <div class="skeleton__box" />
        </div>
        <div class="skeleton__row">
          <div class="skeleton__box" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SkeletonPost",
};
</script>
